class HeaderDrawer extends HTMLElement {
    constructor() {
        super();
        this.toggleDrawerOpen = this.toggleDrawerOpen.bind(this);
        this.toggleDrawerClose = this.toggleDrawerClose.bind(this);
        this.handleSearchInput = this.handleSearchInput.bind(this);
        this.handleSearchFocus = this.handleSearchFocus.bind(this);
        this.handleCrossIconClick = this.handleCrossIconClick.bind(this);
    }

    connectedCallback() {
        this.openButtons = document.querySelectorAll('[drawer-toggle-open]');
        this.closeButtons = document.querySelectorAll('[drawer-toggle-close]');

        this.openButtons.forEach(button => button.addEventListener('click', this.toggleDrawerOpen));
        this.closeButtons.forEach(button => button.addEventListener('click', this.toggleDrawerClose));

        this.browseSubMenu();
        this.searchBarActivate();
    }

    disconnectedCallback() {
        this.openButtons.forEach(button => button.removeEventListener('click', this.toggleDrawerOpen));
        this.closeButtons.forEach(button => button.removeEventListener('click', this.toggleDrawerClose));
        
        this.searchBarDeactivate();
    }

    toggleDrawerOpen() {
        this.classList.add('drawer-open');
        this.classList.remove('drawer-closed');
        document.body.style.overflow = 'hidden';
        document.body.classList.add('overflow-hidden');
    }

    toggleDrawerClose() {
        this.classList.add('drawer-closed');
        if (this.classList.contains('drawer-open')) {
            this.closeSubMenu();
        }
        this.classList.remove('drawer-open');
        document.body.style.overflow = 'auto';
        document.body.classList.remove('overflow-hidden');
    }

    browseSubMenu() {
        const menuItems = this.querySelectorAll('.header-drawer-mega-menu');

        menuItems.forEach(item => {
            const subMenuId = item.dataset.headerMenuId;
            const subMenu = this.querySelector(`#sub-menu-${subMenuId}`);
            const subMenuTrigger = this.querySelector(`#sub-menu-trigger-${subMenuId}`);

            if (subMenu && subMenuTrigger) {
                item.addEventListener('click', () => subMenu.classList.add('!block'));
                subMenuTrigger.addEventListener('click', () => subMenu.classList.remove('!block'));
            }
        });
    }

    closeSubMenu() {
        const menuItems = this.querySelectorAll('.header-drawer-mega-menu');
        menuItems.forEach(item => {
            const subMenuId = item.dataset.headerMenuId;
            const subMenu = this.querySelector(`#sub-menu-${subMenuId}`);
            if (subMenu) {
                subMenu.classList.remove('!block');
            }
        });

        this.searchInput.value = '';
        this.searchInput.blur();
        this.classList.remove('active-search-bar-mobile');
        this.crossIcon.style.display = 'none';
        this.querySelector("#predictive-search").style.display = 'none';

        this.querySelectorAll('details').forEach(item => item.removeAttribute('open'));
    }

    searchBarActivate() {
        this.searchInput = this.querySelector('input[type="search"]');
        this.crossIcon = this.querySelector('.search-bar-cross');

        if (this.searchInput) {
            this.searchInput.addEventListener('input', this.handleSearchInput);
            this.searchInput.addEventListener('focus', this.handleSearchFocus);
        }
        if (this.crossIcon) {
            this.crossIcon.addEventListener('click', this.handleCrossIconClick);
        }
    }

    searchBarDeactivate() {
        if (this.searchInput) {
            this.searchInput.removeEventListener('input', this.handleSearchInput);
            this.searchInput.removeEventListener('focus', this.handleSearchFocus);
        }
        if (this.crossIcon) {
            this.crossIcon.removeEventListener('click', this.handleCrossIconClick);
        }
    }

    handleSearchInput() {
        if (this.searchInput.value.length > 0) {
            this.classList.add('active-search-bar-mobile');
            this.crossIcon.style.display = 'block';
        } else {
            this.classList.remove('active-search-bar-mobile');
            this.crossIcon.style.display = 'none';
        }
    }

    handleSearchFocus() {
        if (this.searchInput.value.length > 0) {
            this.classList.add('active-search-bar-mobile');
        }
    }

    handleCrossIconClick() {
        this.searchInput.value = '';
        this.searchInput.focus();
        this.classList.remove('active-search-bar-mobile');
        this.crossIcon.style.display = 'none';
    }
}

window.customElements.define("header-drawer", HeaderDrawer);
